// extracted by mini-css-extract-plugin
export default {"buttons":"start-montage-modal_buttons__8CTVd"};